import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
// Import the image directly
import profileImage from '../assets/aditi.jpg'; // Adjust the path based on your project structure

function About() {
  // Use the imported image instead of a relative path
  // const profileImage = '../assets/aditi.jpg'; // This won't work reliably in React
  const resumePDF = '#'; // Replace with actual path to your resume

  // Education data
  // const education = [
  //   {
  //     degree: 'Master of Computer Science',
  //     institution: 'Stanford University',
  //     duration: '2018 - 2020',
  //     description: 'Specialized in Artificial Intelligence and Machine Learning with a focus on neural networks and deep learning algorithms.'
  //   },
  //   {
  //     degree: 'Bachelor of Science in Computer Engineering',
  //     institution: 'MIT',
  //     duration: '2014 - 2018',
  //     description: 'Graduated with honors. Focused on software development and computer architecture.'
  //   }
  // ];

  // Experience data
  // const experience = [
  //   {
  //     position: 'Senior Frontend Developer',
  //     company: 'Tech Innovations Inc.',
  //     duration: '2020 - Present',
  //     description: 'Lead the frontend development team in creating responsive web applications using React, Redux, and modern JavaScript. Implemented CI/CD pipelines and improved code quality through automated testing.'
  //   },
  //   {
  //     position: 'Web Developer',
  //     company: 'Digital Solutions LLC',
  //     duration: '2018 - 2020',
  //     description: 'Developed and maintained client websites using JavaScript, HTML5, and CSS3. Collaborated with designers to implement responsive designs and ensure cross-browser compatibility.'
  //   },
  //   {
  //     position: 'Junior Developer',
  //     company: 'StartUp Ventures',
  //     duration: '2016 - 2018',
  //     description: 'Assisted in the development of web applications. Gained experience in frontend technologies and agile development methodologies.'
  //   }
  // ];

  // Skills with proficiency levels
  // const skills = [
  //   { name: 'React', level: 95 },
  //   { name: 'JavaScript', level: 90 },
  //   { name: 'HTML5', level: 95 },
  //   { name: 'CSS3', level: 85 },
  //   { name: 'Node.js', level: 80 },
  //   { name: 'MongoDB', level: 75 },
  //   { name: 'Git', level: 85 },
  //   { name: 'UI/UX Design', level: 70 },
  // ];

  // Skills with proficiency levels
  const skills = [
    // Frontend
    { name: 'React.js', level: 95, url: 'https://react.dev/' },
    { name: 'JavaScript (ES6+)', level: 92, url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript' },
    { name: 'HTML5', level: 95, url: 'https://developer.mozilla.org/en-US/docs/Web/HTML' },
    { name: 'CSS3', level: 88, url: 'https://developer.mozilla.org/en-US/docs/Web/CSS' },
    { name: 'Tailwind CSS', level: 90, url: 'https://tailwindcss.com/docs' },
    { name: 'Bootstrap', level: 85, url: 'https://getbootstrap.com/docs/5.3/' },
    { name: 'Next.js', level: 88, url: 'https://nextjs.org/docs' },
    { name: 'Redux', level: 85, url: 'https://redux.js.org/' },
    { name: 'Material UI (MUI)', level: 82, url: 'https://mui.com/material-ui/' },
    { name: 'Framer Motion', level: 75, url: 'https://www.framer.com/motion/' },
    { name: 'Vue.js', level: 78, url: 'https://vuejs.org/' },
    { name: 'Nuxt.js', level: 75, url: 'https://nuxt.com/' },

    // Backend
    { name: 'Node.js', level: 85, url: 'https://nodejs.org/en/docs/' },
    { name: 'Express.js', level: 83, url: 'https://expressjs.com/' },
    { name: 'NestJS', level: 80, url: 'https://docs.nestjs.com/' },
    { name: 'RESTful API Development', level: 88, url: 'https://restfulapi.net/' },
    { name: 'Django', level: 75, url: 'https://docs.djangoproject.com/' },
    { name: 'Flask', level: 72, url: 'https://flask.palletsprojects.com/' },
    { name: 'PHP', level: 78, url: 'https://www.php.net/docs.php' },

    // Databases
    { name: 'MongoDB (Mongoose)', level: 80, url: 'https://www.mongodb.com/docs/' },
    { name: 'MySQL', level: 85, url: 'https://dev.mysql.com/doc/' },
    { name: 'PostgreSQL', level: 80, url: 'https://www.postgresql.org/docs/' },
    { name: 'MSSQL', level: 78, url: 'https://learn.microsoft.com/en-us/sql/sql-server/' },
    { name: 'Firebase', level: 77, url: 'https://firebase.google.com/docs' },

    // Deployment & Cloud
    { name: 'AWS (EC2, S3)', level: 80, url: 'https://aws.amazon.com/getting-started/' },
    { name: 'Google Cloud Storage (GCS)', level: 78, url: 'https://cloud.google.com/storage/docs' },
    // { name: 'DigitalOcean', level: 76 },
    { name: 'Docker', level: 78, url: 'https://docs.docker.com/' },
    { name: 'Docker Compose', level: 75, url: 'https://docs.docker.com/compose/' },
    // { name: 'NGINX', level: 72 },
    // { name: 'Webpack', level: 70 },
    { name: 'GitHub Actions', level: 73, url: 'https://docs.github.com/en/actions' },
    { name: 'Vercel', level: 82, url: 'https://vercel.com/docs' },
    { name: 'Render', level: 80, url: 'https://render.com/docs' },

    // AI/ML & Others
    // { name: 'AI/ML Integration', level: 70 },
    // { name: 'Python', level: 75 },
    // { name: 'Payment Gateways', level: 85 },
    // { name: 'GPS Tracking', level: 80 },
    // { name: 'Push Notifications', level: 82 },
    // { name: 'UI/UX Design', level: 72 },
    // { name: 'Project Management', level: 82 },
    // { name: 'Client Communication', level: 85 },
    // { name: 'Solution Architecture', level: 80 }
  ];



  // Personal interests
  const interests = [
    'Open Source Contributing',
    'Tech Blogging',
    'Hiking',
    'Photography',
    'Reading',
    'Travel'
  ];

  return (
    <div className="about-container">
      {/* Header Section */}
      <section className="about-header">
        <h1 className="about-title">About <span className="highlight">Me</span></h1>
        <div className="about-subtitle">Get to know me better</div>
      </section>

      {/* Profile Section */}
      <section className="profile-section">
        <div className="profile-grid">
          <div className="profile-image-container">
            <div className="profile-image-wrapper">
              <img
                src={profileImage}
                alt="Profile"
                className="profile-image"
                onError={(e) => {
                  console.error("Image failed to load");
                  e.target.src = 'https://via.placeholder.com/300x300?text=Profile+Image';
                }}
              />
            </div>
          </div>
          <div className="profile-content">

            <h2 className="section-title">Who I <span className="highlight">Am</span></h2>
            {/* <p className="profile-text">
              Hello! I'm Aditi Singh, a passionate web developer with expertise in 
              React, JavaScript, and modern web technologies. I love creating 
              responsive and user-friendly applications that solve real-world problems.
            </p>
            <p className="profile-text">
              With over 5 years of experience in the industry, I've worked on various 
              projects ranging from small business websites to complex enterprise 
              applications. My approach combines technical expertise with creative 
              problem-solving to deliver exceptional digital experiences.
            </p>
            <p className="profile-text">
              I believe in continuous learning and staying updated with the latest 
              technologies and best practices in web development. When I'm not coding, 
              you can find me contributing to open-source projects, writing tech blogs, 
              or exploring the great outdoors.
            </p> */}


            <p className="profile-text">
              Over the years, I’ve worked on diverse projects including e-commerce platforms, mobile healthcare apps, real-time chat systems, interactive games, and productivity tools—each designed with a strong focus on performance, security, and user experience. I take pride in handling the full development lifecycle: from understanding client requirements, designing intuitive UI/UX, and building robust backends to API integrations, testing, production deployment, and post-launch support.
            </p>

            <p className="profile-text">
              I’m committed to continuous learning and staying ahead of the curve with the latest technologies, frameworks, and best practices. Beyond coding, I enjoy exploring AI/ML integrations, contributing to open-source projects, mentoring developers, and occasionally diving into creative hobbies.
            </p>
            <div className="profile-buttons">
              <a
                href={resumePDF}
                download="Aditi_Singh_Resume.pdf"
                className="primary-button"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                Download CV
              </a>
              <Link to="/contact" className="secondary-button">
                Contact Me
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="skills-section">
        <h2 className="section-title">My <span className="highlight">Skills</span></h2>
        <div className="skills-container">
          {skills.map((skill, index) => (
            <a
              key={index}
              href={skill.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="skill-item">
                <div className="skill-info">
                  <span className="skill-name">{skill.name}</span>
                  <span className="skill-percentage">{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div
                    className="skill-progress"
                    style={{ width: `${skill.level}%` }}
                  ></div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Experience Section */}
      {/* <section className="experience-section">
        <h2 className="section-title">Work <span className="highlight">Experience</span></h2>
        <div className="timeline">
          {experience.map((job, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="timeline-title">{job.position}</h3>
                  <span className="timeline-company">{job.company}</span>
                </div>
                <div className="timeline-duration">{job.duration}</div>
                <p className="timeline-description">{job.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Education Section */}
      {/* <section className="education-section">
        <h2 className="section-title">My <span className="highlight">Education</span></h2>
        <div className="timeline">
          {education.map((edu, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="timeline-title">{edu.degree}</h3>
                  <span className="timeline-company">{edu.institution}</span>
                </div>
                <div className="timeline-duration">{edu.duration}</div>
                <p className="timeline-description">{edu.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Interests Section */}
      <section className="interests-section">
        <h2 className="section-title">My <span className="highlight">Interests</span></h2>
        <div className="interests-container">
          {interests.map((interest, index) => (
            <div key={index} className="interest-item">
              <span className="interest-text">{interest}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card">
            <h2 className="cta-title">Interested in working together?</h2>
            <p className="cta-description">
              I'm always open to discussing new projects, creative ideas or opportunities to be part of your vision.
            </p>
            <Link to="/contact" className="cta-button">
              Let's Talk
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;